export default __webpack_public_path__ + "static/media/blue_text.edd35509.png";